module.exports = __webpack_public_path__ + "static/trangle-c5514cd3d9858092561083927cf307c5.jpg";